export const CANDIDATE_INDEX_EXTENSION = '_abtest_candidate';

export const MAX_AVAILABLE_CLIENT_INSTANCES = 5;
export const INSTANCES_ERROR_MESSAGE = `[AlgoliaSearch]: There are too many instances. The number of algolia instances created reaches ${MAX_AVAILABLE_CLIENT_INSTANCES}.`;

// Profiles to display results based on 'hvc-reranking-b2b'
export const HVC_PROFILE_VALUES = ['HIGH', 'VERY_HIGH'];

// Algolia Rule Contexts
export enum RuleContexts {
  DS_RESULTS_ONLY = 'ds-results-only', // @TODO: clean if not used after DS_RESULTS_ONLY ab test
  RERANKING_B2B_HVC = 'hvc-reranking-b2b',
  RERANKING_SEARCH = 'reranking-search',
  RERANKING_SEARCH_ALTERNATE = 'reranking-search-alternate',
  SORTED_LISTINGS = 'sorted-listings',
}

// Enum of string ids for new Feature Flags
export enum StringFeatureFlags {
  ALGOLIA_SEARCH_ENGINE_PROXY = 'algoliaSearchEngineProxy',
}

// Enum of string ids for new AB Tests Flags
export enum ABTests {
  RANKING = 'dsRanking', // @TODO: to change when the current A/B Test is finished
}
